import ChecklistItemRemarkComponent, {
  ChecklistItemRemarkComponentProps,
} from './ChecklistItemRemarkComponent';

export default ChecklistItemRemarkComponent;

export type { ChecklistItemRemarkComponentProps };
